import { AutomatedTextMutations } from './partials/automatedTextTemplate'
import { DocketwiseSettingsMutations } from './partials/docketwise'
import { EngagementLetterMutations } from './partials/engagementLetter'
import { GenericModelSettingsMutations } from './partials/genericModel'
import { InvoicedSettingsMutations } from './partials/invoiced'
import { LegalCasePartySliderSettingsMutations } from './partials/legalCasePartySlider'
import { LegalCasesSettingsMutations } from './partials/legalCases'
import { MiscSettingsMutations } from './partials/misc'
import { MultifactorAuthenticationSettingsMutations } from './partials/multifactorAuthentication'
import { OtherDocketEntriesSettingsMutations } from './partials/otherDocketEntries'
import { RecordsSettingsMutations } from './partials/records'
import { SettingsSharedMutations } from './partials/shared'
import { TimezoneSettingsMutations } from './partials/timezone'
import { TmetricSettingsMutations } from './partials/tmetric'
import { TwilioSettingsMutations } from './partials/twilio'
import { UserAccessSettingsMutations } from './partials/usersAccess'
import { UserSettingsMutations } from './partials/user'
import { WorkflowSettingsMutations } from './partials/workflows'

export const SettingsMutations = {
  ...AutomatedTextMutations,
  ...DocketwiseSettingsMutations,
  ...EngagementLetterMutations,
  ...GenericModelSettingsMutations,
  ...InvoicedSettingsMutations,
  ...LegalCasePartySliderSettingsMutations,
  ...LegalCasesSettingsMutations,
  ...MiscSettingsMutations,
  ...MultifactorAuthenticationSettingsMutations,
  ...OtherDocketEntriesSettingsMutations,
  ...RecordsSettingsMutations,
  ...SettingsSharedMutations,
  ...TimezoneSettingsMutations,
  ...TmetricSettingsMutations,
  ...TwilioSettingsMutations,
  ...UserAccessSettingsMutations,
  ...UserSettingsMutations,
  ...WorkflowSettingsMutations,
}
